"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogActionType = void 0;
var AuditLogActionType;
(function (AuditLogActionType) {
    AuditLogActionType["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    AuditLogActionType["EDIT_OWN_ROLES"] = "EDIT_OWN_ROLES";
    AuditLogActionType["EDIT_OTHER_USER_ROLES"] = "EDIT_OTHER_USER_ROLES";
    AuditLogActionType["EDIT_OWN_EMAIL_SETTINGS"] = "EDIT_OWN_EMAIL_SETTINGS";
    AuditLogActionType["EDIT_OTHER_USER_EMAIL_SETTINGS"] = "EDIT_OTHER_USER_EMAIL_SETTINGS";
    AuditLogActionType["ADD_USER"] = "ADD_USER";
    AuditLogActionType["REQUEST_NEW_CURRENCY_ACCOUNT"] = "REQUEST_NEW_CURRENCY_ACCOUNT";
    AuditLogActionType["DELETE_ACCOUNT_USER"] = "DELETE_ACCOUNT_USER";
    AuditLogActionType["CHANGE_MFA_PREFERENCE"] = "CHANGE_MFA_PREFERENCE";
    AuditLogActionType["CHANGE_LANG_PREFERENCE"] = "CHANGE_LANG_PREFERENCE";
})(AuditLogActionType = exports.AuditLogActionType || (exports.AuditLogActionType = {}));
